
import {
  addToWishlist,
  removeFromWishlist,
} from '@api/like.service'

import {
  mapActions,
  mapState,
} from 'vuex'

import {
  confirmWithPromise,
} from '@utils/helpers'

export default {
  name: 'AddToFavorites',
  props: ['id', 'type'],
  data() {
    return {
    }
  },
  computed: {
    ...mapState('like', [
      'ids',
      'count',
    ]),
    isLiked() {
      return id => this.ids.includes(id)
    },
  },
  methods: {
    ...mapActions('like', [
      'addId',
      'removeId',
    ]),
    add(id) {
      const data = {
        products: this.returnArray(id || this.id),
      }
      addToWishlist
        .execute({}, data)
        .then(() => {
          this.addId(id || this.id)
        })
    },
    async remove(id) {
      const question = this._('Удалить товар из избранного?')
      await confirmWithPromise(question, this)
      const data = {
        products: this.returnArray(id || this.id),
      }
      removeFromWishlist
        .execute({}, data)
        .then(() => {
          window.location.reload()
        })
    },
    returnArray(id) {
      return Array.isArray(id) ? id : [id]
    },
  },
  render() {
    window.umallAddToFavorites = this.add
    window.umallRemoveFromFavorites = this.remove
    window.umallIsInFavorites = this.isLiked
    return this.$scopedSlots.default({
      add: () => this.add(),
      remove: () => this.remove(),
      is_added: this.isLiked(this.id),
    })
  },
}
